<template>
    <label v-for="(item, idx) in items"
    :key="idx"
    :class="[item.labelClassName, `radiobtn-item`, { 'highlight-radio': item.highlight, 'highligh-stretch': item.highlightStretch }]"
    :for="item.key">
        <input
            type="radio"
            :name='item.name'
            :id="item.key"
            :value="item.key"
            :checked="item.checked"
            :disabled="item.disable"
            @change="changeHandler"
            />

        <span v-html="$t(item.value,item.period)"></span>

    </label>
</template>

<script setup>
import { defineEmits,defineProps, ref , watch } from 'vue';
    const emit    = defineEmits(["onChange"]);

    const props = defineProps({
        items: Array
    });

    const items = ref(props.items);
    watch(props, (newVal) => {
        items.value = newVal.items;
        console.log('radio newval',newVal.items);

    })

    const changeHandler = (e) => {
        items.value.forEach(ob => {
            ob.checked = false;
            if(ob.key == e.target.value) ob.checked = true;
        });

        emit("onChange", {
            all        : items.value,
            selected   : items.value.filter(ob => ob.checked)[0],
            unSelected : items.value.filter(ob => !ob.checked)[0],
        });
    }

</script>
<!--


 -->

<style lang="scss" scoped>
@import "@/assets/scss/components/ui/radioBtn.scss";
</style>
